export const userNameFilter = function (input: any) {
  if (!input) return "";
  const userName = input.toString();

  const re = /^User-[0-9]{10}/;
  if (re.test(userName)) {
    return userName.slice(0, 10);
  } else {
    return userName;
  }
};
